import SliderAdvanced from './SliderAdvanced';
export default SliderAdvanced;
